import { Link } from "react-router-dom";

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  kicker,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div className="min-w-0">
        {kicker && (
          <p className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.22em] text-accent-700">
            <span className="h-px w-6 bg-accent-400" />
            {kicker}
          </p>
        )}
        <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">
            {description}
          </p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="group inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300/70 px-4 py-2 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}